const unique = students => [...new Map(students.map(student => [student.id, student])).values()];
const normalized = value => (value || '').trim().toLocaleLowerCase('pl');
const unmarked = value => normalized(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l');

export function getStudentMergeSuggestions(studentsA, studentsB) {
  const suggestions = [];
  studentsB.filter(b => !b.archived).forEach(b => studentsA.filter(a => !a.archived && a.id !== b.id).forEach(a => {
    if (!normalized(a.firstName) || !normalized(b.firstName)) return;
    let reason = null;
    if (unmarked(a.firstName) === unmarked(b.firstName)) reason = 'diacritics';
    if (normalized(a.firstName) === normalized(b.firstName)) reason = 'sameFirstName';
    if (reason) suggestions.push({ studentAId: a.id, studentBId: b.id, reason });
  }));
  return suggestions;
}

export function buildStudentMergeView({ studentsA = [], studentsB = [], blockers = [] }, decisions = {}) {
  const aList = unique(studentsA); const bList = unique(studentsB);
  const shared = new Set(aList.filter(a => bList.some(b => b.id === a.id)).map(a => a.id));
  const pairs = new Map(); const used = new Set(); const errors = [];
  Object.entries(decisions).forEach(([id, decision]) => {
    if (!decision.merge) return;
    const a = aList.find(s => s.id === decision.mergeWith); const b = bList.find(s => s.id === id);
    if (!a || !b || a.archived || b.archived || a.id === b.id || shared.has(id) || shared.has(a.id) || used.has(a.id)) {
      errors.push('INVALID_STUDENT_PAIR'); return;
    }
    pairs.set(id, a.id); used.add(a.id);
  });
  blockers.filter(item => item.scope === 'operation' || pairs.get(item.studentBId) === item.studentAId).forEach(item => errors.push(item.code));
  const rows = aList.map(a => {
    const b = bList.find(student => pairs.get(student.id) === a.id);
    let status = b ? 'paired' : 'retained';
    if (shared.has(a.id)) status = 'shared';
    return { key: `a-${a.id}`,
      studentA: a,
      studentB: shared.has(a.id) ? a : b,
      result: a,
      status };
  });
  bList.filter(b => !pairs.has(b.id) && !shared.has(b.id)).forEach(b => {
    rows.push({ key: `b-${b.id}`, studentB: b, result: b, status: 'transferred' });
  });
  const counts = { total: rows.length,
    active: rows.filter(row => !row.result.archived).length,
    archived: rows.filter(row => row.result.archived).length };
  ['retained', 'transferred', 'paired', 'shared'].forEach(status => { counts[status] = rows.filter(row => row.status === status).length; });
  return { rows, counts, errors: [...new Set(errors)], shared };
}
